function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
} /* eslint-disable @typescript-eslint/no-non-null-assertion */
import getArhiConfig from "./arhi";
import { ProfileSystemIcon } from "@nib/icons";
const PHONE_NUMBER = "1800 775 204";
const CORPORATE_PHONE_NUMBER = null;
const getInternationalConfig = config => {
  const arhiConfig = getArhiConfig(config);
  return _objectSpread(_objectSpread({}, arhiConfig), {}, {
    id: "header-international",
    phoneNumber: PHONE_NUMBER,
    corporatePhoneNumber: CORPORATE_PHONE_NUMBER,
    smallHeaderConfig: {
      id: "small-header-international",
      logoUrl: arhiConfig.logoUrl,
      phoneNumber: PHONE_NUMBER,
      corporatePhoneNumber: CORPORATE_PHONE_NUMBER,
      navLinks: [{
        id: "ga-nav-international-my-account",
        label: arhiConfig.callToAction.title,
        title: arhiConfig.callToAction.title,
        icon: ProfileSystemIcon,
        url: arhiConfig.callToAction.url
      }]
    }
  });
};
export default getInternationalConfig;